import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Setup from "./routes/Setup";
import YearGroups from "./routes/YearGroups";
import TemplateConfig from "./routes/TemplateConfig";
export default store => ({
  path: "transcripts",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "transcript-chunk" */ "./components"),
        import(
          /* webpackChunkName: "transcript-chunk" */ "./modules/TranscriptModules"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "transcripts",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Setup(store), YearGroups(store), TemplateConfig(store)],
});
